import FuseAnimate from '@/@fuse/core/FuseAnimate';
import Typography from '@material-ui/core/Typography';
import React from 'react';
import { Link } from 'react-router-dom';

const Error404Page = () => {
	return (
		<div className="flex flex-col flex-1 items-center justify-center p-16 bg-[url('/assets/images/banner/bg.png')] bg-no-repeat bg-center bg-cover">
			<div className="max-w-512 text-center bg-white rounded-3xl p-24 shadow-lg">
				<FuseAnimate animation="transition.expandIn" delay={100}>
					<Typography className="font-medium mb-16 text-black" color="inherit" variant="h1">
						404
					</Typography>
				</FuseAnimate>

				<FuseAnimate delay={500}>
					<p className="mb-16 text-16 text-black">Sorry but we could not find the page you are looking for</p>
				</FuseAnimate>

				<Link to="/" className="font-medium text-20 text-pd-blue">
					Go back to dashboard
				</Link>
			</div>
		</div>
	);
};

export default Error404Page;
